import {Component,Input, OnInit, ViewChild} from '@angular/core';
import {ReportItem} from "../report-item";
import {Items} from "../../../@models/pdf-report/items";

@Component({
	selector: 'app-pdf-view-blocks-doctors',
	templateUrl: './pdf-view-blocks-doctors.component.html',
	styleUrls: ['./pdf-view-blocks-doctors.component.scss']
})
export class PdfViewBlocksDoctorsComponent implements OnInit, ReportItem {

	@Input()
	tableData: Items;

	constructor() {
	}
	@ViewChild('element', { static: true })
	public element;

	ngOnInit() {
		//console.log(this.tableData);
	}
}
